import { render, staticRenderFns } from "./AtomRoute.vue?vue&type=template&id=3b784fd7&"
import script from "./AtomRoute.vue?vue&type=script&lang=js&"
export * from "./AtomRoute.vue?vue&type=script&lang=js&"
import style0 from "./AtomRoute.vue?vue&type=style&index=0&id=3b784fd7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
